 <template>
 <div>
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

     <div>

     </div>
 <div>
  <v-data-table
    :headers="headers"
    :items="bancos"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Bancos

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initialize(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>
<div>
    <v-alert v-if="sucess" type="success">
      Cadastro feito com sucesso.
    </v-alert>

    <v-alert v-if="err" type="error">
      O Cadastro não foi feito com sucesso.
    </v-alert>
  </div>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="12" sm="12" md="12">

                      <v-text-field
                        v-model="editedItem.nome"
                        label="Nome do banco"
                         :rules="obrigqtorioRules"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
export default {
  directives: { mask },
  data: () => ({
    text: '',
    flag_curso: '',
    formValid: true,
    usuarios: [],
    isLoading: false,
    search: '',
    cursos: [],
    usuariosJaExistentes: [],
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    bancos: [],
    sucess: false,
    err: false,
    dialog: false,
    headers: [
      {
        text: 'Nome do Banco',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Modificado', value: 'auto_data' }
    ],

    editedIndex: -1,
    editedItem: {
      pkbanco: 0,
      nome: ''
    },
    defaultItem: {
      pkbanco: 0,
      nome: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo ' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },

  methods: {

    async initialize (search) {
      this.isLoading = true
      var payload = ''
      try {
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.bancos = await axios
          .get('/bancosAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.bancos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.bancos.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
      this.bancos.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.$refs.form.validate() && this.editedItem.nome) {
        try {
          var params = {
            pkbanco: this.editedItem.pkbanco,
            nome: this.editedItem.nome

          }
        } catch (error) {

        }

        try {
          let msg = await axios
            .post('/bancoInsertOrUpdate', params)
            .then(res => res.data)
            // this.text = msg[1].insertId

          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.bancos.unshift(params)
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
              this.sucess = true
              setTimeout(() => {
                this.sucess = false
              }, 2000)
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
            this.err = true
            setTimeout(() => {
              this.err = false
            }, 2000)
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
          this.editedItem.pkbanco = 0
          this.editedItem.nome = ''
          this.close()
        }
      }
    }
  }

}
</script>
